import React from 'react';
import { Modal, Form } from 'antd';
import { CustomButton, CustomTextArea, FormSelect } from '../../../../../components';
import { useFormik } from 'formik';

interface ModalGestionEstadosProps {
  isOpen: boolean;
  onClose: () => void;
  selectedIds: number[];
  assetId: string;
  onSuccess?: () => void;
  onSave: (updates: { id: number; status_id: number; observations: string }[]) => void;
}

const ModalGestionEstados: React.FC<ModalGestionEstadosProps> = ({ isOpen, onClose, selectedIds, assetId, onSuccess, onSave }) => {
  const status = [
    { id: 15, status: 'Recibido' },
    { id: 10, status: 'Rechazado' }
  ];

  const formik = useFormik({
    initialValues: {
      estadoElemento: '',
      descripcionRevision: '',
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const updates = selectedIds.map((id) => ({
        id,
        status_id: Number(values.estadoElemento),
        observations: values.descripcionRevision,
      }));

      onSave(updates); 
      onClose();      
    },
  });

 

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      width={1000}
      title="¿Desea gestionar el estado de los elementos seleccionados?"
      footer={[
        <CustomButton key="cancel" label="Cancelar" onClick={onClose} buttonType="secondary" />,
    <CustomButton key="save" label="Guardar" onClick={formik.submitForm} />,
      ]}
    >
      <Form layout="vertical" onFinish={formik.handleSubmit}>
        <FormSelect
          label="Estado del elemento"
          name="estadoElemento"
          placeholder="Seleccione"
          value={formik.values.estadoElemento}
          onChange={(value) => formik.setFieldValue("estadoElemento", value)}
          onBlur={() => formik.setFieldTouched("estadoElemento", true)}
          options={status.map((x) => ({ name: x.status, id: x.id.toString() }))}
        />

        <CustomTextArea
          label="Observaciones"
          name="descripcionRevision"
          placeholder="Observaciones"
          value={formik.values.descripcionRevision}
          error={formik.errors.descripcionRevision}
          touched={formik.touched.descripcionRevision}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Form>
    </Modal>
  );
};

export default ModalGestionEstados;